'use client';

import { useTranslations } from 'next-intl';
import { Disclosure } from '~/components/Disclosure';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import styles from './FAQs.module.css';

type TripOverviewFaq = {
  id: string;
  question: string;
  answer: string;
};

type FAQsProps = {
  items: TripOverviewFaq[];
  title?: string;
};

export function FAQs({ items, title }: Readonly<FAQsProps>) {
  const t = useTranslations('journey');
  const isDesktop = useIsDesktop();

  if (items.length === 0) return null;

  return (
    <section id="overview-faqs" className={styles.section} aria-labelledby="trip-v2-faqs-heading">
      <h2 id="trip-v2-faqs-heading" className={styles.heading}>
        {title ?? t('overview_tab_faqs')}
      </h2>

      <ul className={styles.list}>
        {items.map((faq) => (
          <li key={faq.id} className={styles.item}>
            <Disclosure title={faq.question} size={isDesktop ? 'md' : 'sm'} headingLevel="h3" noBorder={!isDesktop}>
              <p className={styles.answer}>{faq.answer}</p>
            </Disclosure>
          </li>
        ))}
      </ul>
    </section>
  );
}
